import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

export const reloadPage = () => {
  window.location.reload();
};

/**
 * Cria identificador único,
 * útil para ser usado como ID de tags HTML
 * @param prefix Prefixo do identificador
 */
export const createIdentifier = (prefix = 'id') => {
  const chr4 = () => Math.random().toString(16).slice(-4);
  return `${prefix}-${chr4()}${chr4()}-${chr4()}-${chr4()}-${chr4()}-${chr4()}${chr4()}${chr4()}`;
};

/**
 * Obtém o nome do arquivo a partir do header content-disposition
 */
export const getFilenameFromHeaders = (
  headers: AxiosResponseHeaders | Partial<RawAxiosResponseHeaders>
) => {
  return headers['content-disposition'].split('filename=')[1].slice(1, -1);
};
